import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4","key":"svg-1"}],["path",{"d":"M5 21h14","key":"svg-2"}],["path",{"d":"M5 18h14","key":"svg-3"}],["path",{"d":"M5 15h14","key":"svg-4"}]]

const IconFileStack = createReactComponent('outline', 'file-stack', 'FileStack', __iconNode);

export default IconFileStack;